import React from 'react';
import {
  PortalOverlay,
  PortalOverlayHeader,
  PortalOverlayHeaderCloseBtn,
  PortalOverlayModal,
  Stack,
  BodyText,
  Button,
  HeaderText,
} from '../../../ui';

export type ApptSmsInviteDialogProps = {
  onSendInvite: () => void;
  onClose: () => void;
};

export const ApptSmsInviteDialog: React.FC<ApptSmsInviteDialogProps> = ({
  onSendInvite,
  onClose,
}) => (
  <PortalOverlay
    name="appt-sms-invite-dialog"
    onBackdropClick={onClose}
  >
    <PortalOverlayModal position="growDialog" testID="sms-invite-dialog">
      <PortalOverlayHeader
        renderRightAction={() => (
          <PortalOverlayHeaderCloseBtn onCloseRequest={onClose} />
        )}
      />
      <Stack padding={16} alignItems="center" space={28}>
        <HeaderText level={2} textAlign="center">
          Invite client to turn on text notifications
        </HeaderText>
        <BodyText textAlign="center">
          Receiving appointment reminders, managing payment methods,
          and receiving payment requests are just a few of the benefits
          clients have at their fingertips with text messaging enabled.
          Invite now to turn on.
        </BodyText>
        <Button appearance="primary-neue" onClick={onSendInvite} testID="sms-invite-dialog-send-invite">
          Send Invite
        </Button>
        <BodyText appearance="smaller" textAlign="center">
          By inviting, you acknowlege that the number provided for this client is accurate,
          and that this client has requested automated text reminders
          and info about their StyleSeat appointments.
        </BodyText>
      </Stack>
    </PortalOverlayModal>
  </PortalOverlay>
);
